if (!customElements.get('product-add-ons')) {
  customElements.define(
    'product-add-ons',
    class ProductAddOns extends HTMLElement {
      connectedCallback() {
        this.summary = this.querySelector('[data-add-ons-summary]');
        this.summaryText = this.querySelector('[data-add-ons-summary-text]');
        this.addEventListener('change', this.update.bind(this));
        this.update();
      }

      // Keeps each card's price, highlight and the running total in step with the switches and option dropdowns.
      update() {
        let count = 0;
        let total = 0;

        this.querySelectorAll('.product-add-ons__item').forEach((item) => {
          const toggle = item.querySelector('[data-add-on]');
          const select = item.querySelector('[data-add-on-variant]');
          const option = select ? select.selectedOptions[0] : null;

          if (option) {
            toggle.value = option.value;
            toggle.dataset.price = option.dataset.price;
            const priceLabel = item.querySelector('[data-add-on-price]');
            if (priceLabel) priceLabel.textContent = option.dataset.priceLabel;
          }

          item.classList.toggle('is-selected', toggle.checked);
          if (toggle.checked) {
            count += 1;
            total += Number(toggle.dataset.price) || 0;
          }
        });

        if (!this.summary) return;
        this.summary.hidden = count === 0;
        this.summaryText.textContent = `${count} ${count === 1 ? 'add-on' : 'add-ons'} added · +${this.formatMoney(total)}`;
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          const commaDecimal = key.includes('comma_separator');
          const [whole, decimals] = (cents / 100).toFixed(key.includes('no_decimals') ? 0 : 2).split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, commaDecimal ? '.' : ',');
          return decimals ? `${grouped}${commaDecimal ? ',' : '.'}${decimals}` : grouped;
        });
      }
    }
  );
}
